if (document.getElementById('page-workplace')) {
  page()
}
function page() {
  //   ####   #####   ##   ##  ##     ##  ######
  //  ##     ##   ##  ##   ##  ####   ##    ##
  //  ##     ##   ##  ##   ##  ##  ## ##    ##
  //  ##     ##   ##  ##   ##  ##    ###    ##
  //   ####   #####    #####   ##     ##    ##
  /*
  数字データのカウントアップ
  data-count-start 初期値
  data-count-end 最終値
  data-count-step ステップ　省略で自動計算
  <span class="js-inCount" data-count-start="0" data-count-end="100" data-count-step="">0</span>
  */
  //

  //            ##  ##     ##
  //            ##  ####   ##
  //  ########  ##  ##  ## ##
  //            ##  ##    ###
  //            ##  ##     ##
  // 画面に入った監視対象をカウントアップ
  // Intersection Observer
  window.intObsCount = function () {
    if (!document.getElementsByClassName('js-inCount')[0]) {
      return
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.querySelectorAll('.js-inCount:not(.counted)')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('counted')

          const countStart = parseFloat(entryItem.dataset.countStart) // 初期値
          const countEnd = parseFloat(entryItem.dataset.countEnd) // 最終値
          let countStep = parseFloat(entryItem.dataset.countStep) // ステップ

          // ステップがなければ自動計算
          if (!countStep) {
            countStep = Math.floor((countEnd - countStart) / 80)
            if (countStep < 1) {
              countStep = 1
            }
          }

          valCountUp(entryItem, countStart, countEnd, countStep)

          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
  window.intObsCount() // 画面交差API起動

  //             ####   #####   ##   ##  ##     ##  ######
  //            ##     ##   ##  ##   ##  ####   ##    ##
  //  ########  ##     ##   ##  ##   ##  ##  ## ##    ##
  //            ##     ##   ##  ##   ##  ##    ###    ##
  //             ####   #####    #####   ##     ##    ##
  // 再帰的なカウント描画
  function valCountUp(item, countStart, countEnd, countStep = 1) {
    countStart = !countStart ? 0 : countStart

    const countSplit = String(countStart).split('.') // 小数点を基準に分割

    if (countSplit[1]) {
      // 小数点がある場合
      item.innerHTML = '<span class="">' + countSplit[0] + '.</span>' + (countSplit[1] ? countSplit[1] : 0)
    } else {
      item.innerHTML = '<span class="">' + countSplit[0] + '</span>'
    }
    if (countStart === countEnd) {
      // 数えきったら終了
      return
    }

    countStart += countStep // カウントを進める
    if (countStart > countEnd) {
      // オーバーしたら最大値に揃える
      countStart = countEnd
    }

    if (countStart <= countEnd) {
      // 目標値までカウントしていなければ再帰呼び出し
      let timerVal = 5 // カウントマイクロ秒
      const progress = countStart / countEnd // 進捗を求める

      // 進捗に応じて加減速
      if (progress <= 0.4) {
        timerVal = 1
      }
      if (progress >= 0.9) {
        timerVal = 50
      }
      setTimeout(function () {
        valCountUp(item, countStart, countEnd, countStep)
      }, timerVal)
    }
  }
}
